import { RouteRecordRaw } from 'vue-router';
import RouterView from '@/components/routerView/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/mp',
    component: RouterView,
    children: [
      {
        path: 'qrcode',
        name: 'qrcode',
        component: () => import(/* webpackChunkName: "qrcode" */ '@/views/mp/qrcode/qrcode.vue')
      }
    ]
  }
]

export default routes
